import { Box, keyframes } from '@mui/material';
import React from 'react';

import { AgentStatusDotProps } from './AgentStatusDot.props';
import { STATUS_COLORS } from '../../../configs/connect';

const pulseAnimation = keyframes`
  0%   { box-shadow: 0 0 0 0 currentColor; }
  70%  { box-shadow: 0 0 0 6px transparent; }
  100% { box-shadow: 0 0 0 0 transparent; }
`;

export const AgentStatusDot: React.FC<AgentStatusDotProps> = ({
  kind,
  pulse = false,
  size = 8,
}) => {
  const color = STATUS_COLORS[kind];
  return (
    <Box
      role="presentation"
      aria-label={`Status: ${kind}`}
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        bgcolor: color,
        color,
        flexShrink: 0,
        animation: pulse ? `${pulseAnimation} 1.4s ease-out infinite` : 'none',
      }}
    />
  );
};
